<template>
    <div>
        <Row :gutter="20">
            <Col span="12">
                <FormItem label="单位名称" prop="comName">
                    <Input v-model="info.comName" :maxlength="100"></Input>
                </FormItem>
            </Col>
        </Row>
        <Row :gutter="20">
            <Col span="12">
                <FormItem label="实收金额">
                    <input-number :value="info.realAmount" placeholder disabled>
                        <span slot="append">元</span>
                    </input-number>
                </FormItem>
            </Col>
            <Col span="12">
                <FormItem label="已收款时间">
                    <DatePicker
                        :value="info.realDate"
                        style="width: 100%"
                        type="datetime"
                        placeholder
                        disabled
                    />
                </FormItem>
            </Col>
        </Row>
        <Row :gutter="20">
            <Col span="12">
                <FormItem label="实付金额">
                    <input-number :value="info.realAmount" placeholder disabled>
                        <span slot="append">元</span>
                    </input-number>
                </FormItem>
            </Col>
            <Col span="12">
                <FormItem label="已付款时间">
                    <DatePicker
                        :value="info.realDate"
                        style="width: 100%"
                        type="datetime"
                        placeholder
                        disabled
                    />
                </FormItem>
            </Col>
        </Row>
        <Row :gutter="20">
            <Col span="12">
                <FormItem prop="feeType" label="费用类型">
                    <Select
                        v-model="info.feeType"
                        transfer
                        placeholder
                        style="width: 210px; display: inline-block"
                    >
                        <Option
                            v-for="item in dict.feeType.toList()"
                            :value="item.id"
                            :key="item.id"
                            >{{ item.text }}</Option
                        >
                    </Select>
                </FormItem>
            </Col>
            <Col span="12">
                <FormItem prop="invalidTime" label="作废时间">
                    <DatePicker
                        v-model="info.invalidTime"
                        style="width: 100%"
                        type="datetime"
                        placeholder
                        disabled
                    />
                </FormItem>
            </Col>
        </Row>
    </div>
</template>

<script>
export default {
    props: {
        info: {
            type: Object,
            default: () => ({}),
        },
        dict: {
            type: Object,
            default: () => ({}),
        },
    },
}
</script>
